import { useEffect, useState } from "react";
import "./css/cotizarepuestos.css"
import { Card, Container } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import "../../global.css"
import Col from "react-bootstrap/Col";
import { useHistory } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import ReactSelect from "react-select";
import { verificarCedula } from "udv-ec";
import InputMask from "react-input-mask";
import FiltroAire from "../../images/servicio/repuestos/filtro-aire/filtro-aire.webp";
import FiltroAire2 from "../../images/servicio/repuestos/filtro-aire/filtro-aire2.webp";
import PastillaFreno from "../../images/servicio/repuestos/pastilla-freno/pastilla-freno.webp";
import PastillaFreno2 from "../../images/servicio/repuestos/pastilla-freno/pastilla-freno2.webp";
import FiltroCabina from "../../images/servicio/repuestos/filtro-cabina/filtro-cabina.webp";
import FiltroCabina2 from "../../images/servicio/repuestos/filtro-cabina/filtro-cabina2.webp";
import FiltroCombustible from "../../images/servicio/repuestos/filtro-combustible/filtro-combustible.webp";
import FiltroCombustible2 from "../../images/servicio/repuestos/filtro-combustible/filtro-combustible2.webp";
import FiltroAceite from "../../images/servicio/repuestos/filtro-aceite/filtro-aceite.webp";
import FiltroAceite2 from "../../images/servicio/repuestos/filtro-aceite/filtro-aceite2.webp";
import BandaDistribucion from "../../images/servicio/repuestos/banda-distribucion/banda-distribucion.webp";
import BandaDistribucion2 from "../../images/servicio/repuestos/banda-distribucion/banda-distribucion2.webp";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import AOS from "aos";
import Swal from "sweetalert2";
import { Backdrop, CircularProgress, makeStyles } from "@material-ui/core";
import { servicioObtenerCiudades, servicioObtenerConcesionarios } from "../../services/serviciosAPI";
import { servicioGuardarCotizacionRepuestos } from "../../services/serviciosRepuestos";
import cuid from "cuid";

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

function InfoCotizaRepuestos() {
    const classes = useStyles();
    const { register, control, handleSubmit, setValue, formState: { errors } } = useForm({
        defaultValues: {
            identificacion: "",
            nombre: "",
            apellido: "",
            telefono: "",
            celular: "",
            correo: "",
            selectCiudad: "",
            selectConcesionario: "",
            descripcionRepuesto: "",
            chasis: "",
        }
    });
    const history = useHistory();
    const [listaConcesonarios, setListaConcesionarios] = useState([]);
    const [listaCiudades, setListaCiudades] = useState([]);
    const [showBackdrop, setShowBackdrop] = useState(false);

    useEffect(() => {
        AOS.init({
            duration: 1000,
        });

        const obtenerCiudades = async () => {
            console.time("t1");
            const response = await servicioObtenerCiudades();
            console.timeEnd("t1");
            var listaCiudadesSelect = response?.map(
                (row) => {
                    return {
                        'id': row.CIU_CODIGO,
                        'value': row.CIU_NOMBRE,
                        'label': row.CIU_NOMBRE
                    }
                }
            )
            setListaCiudades(listaCiudadesSelect);
        };
        obtenerCiudades();
    }, []);

    const onSubmit = async (formData) => {
        const dataForm = new FormData();
        let cid = cuid();
        dataForm.append("id", cid);
        dataForm.append('nombre', formData.nombre);
        dataForm.append('apellido', formData.apellido)
        dataForm.append('identificacion', formData.identificacion)
        dataForm.append('celular', formData.celular)
        dataForm.append('telefono_convencional', formData.telefono)
        dataForm.append('email', formData.correo)
        dataForm.append('ciudad', formData.selectCiudad?.id)
        dataForm.append('nombre_ciudad', formData.selectCiudad?.value)
        dataForm.append('modelo', "")
        dataForm.append('repuesto', formData.descripcionRepuesto)
        dataForm.append('anio', "")
        dataForm.append('chasis', formData.chasis)
        dataForm.append('cod_concesionario', formData.selectConcesionario?.cod_concesionario)
        dataForm.append('cod_empresa', formData.selectConcesionario?.cod_empresa)
        dataForm.append('detalle_concesionario', formData.selectConcesionario?.label)
        setShowBackdrop(true);
        const respuestaServicio = await servicioGuardarCotizacionRepuestos(dataForm);
        if (respuestaServicio?.status) {
            limpiarFormulario();
            Swal.fire({
                title: "ÉXITO",
                text: "Su cotización fue generada con éxito, pronto un asesor Hyundai te contactará.",
                showCloseButton: true,
                icon: "success",
            });
            history.push(`/gracias-repuesto`);
        } else {
            Swal.fire({
                title: "Información",
                text: "No se pudo generar la cotización, por favor intente en unos minutos.",
                showCloseButton: true,
                icon: "info",
            });
        }
        setShowBackdrop(false);
    }

    const limpiarFormulario = () => {
        setValue('identificacion', "");
        setValue('nombre', "");
        setValue('apellido', "");
        setValue('telefono', "");
        setValue('celular', "");
        setValue('correo', "");
        setValue('selectCiudad', "");
        setValue('selectConcesionario', "");
        setValue('descripcionRepuesto', "");
        setValue('chasis', "");
    }

    const leerCiudad = async (item) => {
        setListaConcesionarios([]);
        setValue('selectConcesionario', '')
        obtenerConcecionarios(item.id);
    }

    const obtenerConcecionarios = async (ciudad) => {
        const response = await servicioObtenerConcesionarios(ciudad);
        var listaConcesionariosSelect = response?.map(
            (row) => {
                return {
                    'id': parseInt(row.ALM_COD_SGC),
                    'value': row.ALM_COD_SGC,
                    'cod_concesionario': row.ALM_CODIGO,
                    'cod_empresa': row.ALM_EMPRESA,
                    'label': `(${row.EMP_NOMBRE_COMERCIAL}) - ${row.ALM_NOMBRE} - ${row.ALM_DIRECCION}`
                }
            }
        )
        setListaConcesionarios(listaConcesionariosSelect)
    }

    //Copia repuestos antiguos.
    const onChangeMenu = (menu) => {
        switch (menu) {
            case "filtro-aire":
                document.getElementById("tab-filtro-aire").className = "color-hover";
                document.getElementById("tab-pastilla-freno").className = "color-normal";
                document.getElementById("tab-filtro-aire-cab").className = "color-normal";
                document.getElementById("tab-filtro-comb").className = "color-normal";
                document.getElementById("tab-filtro-aceite").className = "color-normal";
                document.getElementById("tab-banda-distribucion").className = "color-normal";
                document.getElementById("filtro-aire").className = "d-block";
                document.getElementById("pastilla-freno").className = "d-none";
                document.getElementById("filtro-aire-cab").className = "d-none";
                document.getElementById("filtro-comb").className = "d-none";
                document.getElementById("filtro-aceite").className = "d-none";
                document.getElementById("banda-distribucion").className = "d-none";
                break;
            case "pastilla-freno":
                document.getElementById("tab-filtro-aire").className = "color-normal";
                document.getElementById("tab-pastilla-freno").className = "color-hover";
                document.getElementById("tab-filtro-aire-cab").className = "color-normal";
                document.getElementById("tab-filtro-comb").className = "color-normal";
                document.getElementById("tab-filtro-aceite").className = "color-normal";
                document.getElementById("tab-banda-distribucion").className = "color-normal";
                document.getElementById("filtro-aire").className = "d-none";
                document.getElementById("pastilla-freno").className = "d-block";
                document.getElementById("filtro-aire-cab").className = "d-none";
                document.getElementById("filtro-comb").className = "d-none";
                document.getElementById("filtro-aceite").className = "d-none";
                document.getElementById("banda-distribucion").className = "d-none";
                break;
            case "filtro-aire-cab":
                document.getElementById("tab-filtro-aire").className = "color-normal";
                document.getElementById("tab-pastilla-freno").className = "color-normal";
                document.getElementById("tab-filtro-aire-cab").className = "color-hover";
                document.getElementById("tab-filtro-comb").className = "color-normal";
                document.getElementById("tab-filtro-aceite").className = "color-normal";
                document.getElementById("tab-banda-distribucion").className = "color-normal";
                document.getElementById("filtro-aire").className = "d-none";
                document.getElementById("pastilla-freno").className = "d-none";
                document.getElementById("filtro-aire-cab").className = "d-block";
                document.getElementById("filtro-comb").className = "d-none";
                document.getElementById("filtro-aceite").className = "d-none";
                document.getElementById("banda-distribucion").className = "d-none";
                break;
            case "filtro-comb":
                document.getElementById("tab-filtro-aire").className = "color-normal";
                document.getElementById("tab-pastilla-freno").className = "color-normal";
                document.getElementById("tab-filtro-aire-cab").className = "color-normal";
                document.getElementById("tab-filtro-comb").className = "color-hover";
                document.getElementById("tab-filtro-aceite").className = "color-normal";
                document.getElementById("tab-banda-distribucion").className = "color-normal";
                document.getElementById("filtro-aire").className = "d-none";
                document.getElementById("pastilla-freno").className = "d-none";
                document.getElementById("filtro-aire-cab").className = "d-none";
                document.getElementById("filtro-comb").className = "d-block";
                document.getElementById("filtro-aceite").className = "d-none";
                document.getElementById("banda-distribucion").className = "d-none";
                break;
            case "filtro-aceite":
                document.getElementById("tab-filtro-aire").className = "color-normal";
                document.getElementById("tab-pastilla-freno").className = "color-normal";
                document.getElementById("tab-filtro-aire-cab").className = "color-normal";
                document.getElementById("tab-filtro-comb").className = "color-normal";
                document.getElementById("tab-filtro-aceite").className = "color-hover";
                document.getElementById("tab-banda-distribucion").className = "color-normal";
                document.getElementById("filtro-aire").className = "d-none";
                document.getElementById("pastilla-freno").className = "d-none";
                document.getElementById("filtro-aire-cab").className = "d-none";
                document.getElementById("filtro-comb").className = "d-none";
                document.getElementById("filtro-aceite").className = "d-block";
                document.getElementById("banda-distribucion").className = "d-none";
                break;
            case "banda-distribucion":
                document.getElementById("tab-filtro-aire").className = "color-normal";
                document.getElementById("tab-pastilla-freno").className = "color-normal";
                document.getElementById("tab-filtro-aire-cab").className = "color-normal";
                document.getElementById("tab-filtro-comb").className = "color-normal";
                document.getElementById("tab-filtro-aceite").className = "color-normal";
                document.getElementById("tab-banda-distribucion").className = "color-hover";
                document.getElementById("filtro-aire").className = "d-none";
                document.getElementById("pastilla-freno").className = "d-none";
                document.getElementById("filtro-aire-cab").className = "d-none";
                document.getElementById("filtro-comb").className = "d-none";
                document.getElementById("filtro-aceite").className = "d-none";
                document.getElementById("banda-distribucion").className = "d-block";
                break;
            default:
                break;
        }
    };

    return (
        <div>
            <div className='fondo-repuestos'>
                <section className='textos-header pl-5 pr-5'>
                    <h1 data-aos="fade-right" className="text-center"
                    >Repuestos Originales</h1>
                    <h1 data-aos="fade-right" className="text-center"
                    >que garantizan tu tranquilidad</h1>
                </section>
                <div className='wave-repuestos'>
                    <svg viewBox="0 0 500 150" preserveAspectRatio="none" style={{ height: '100%', width: '100%' }}>
                        <path d="M0.00,49.99 C150.00,150.00 349.20,-49.99 500.00,49.99 L500.00,150.00 L0.00,150.00 Z"
                            style={{ stroke: 'none', fill: 'white' }}></path>
                    </svg>
                </div>
            </div>
            <div>
                <Container>
                    <Row className="centrar-global">
                        <Backdrop open={showBackdrop} className={classes.backdrop}>
                            <CircularProgress color="inherit" />
                        </Backdrop>
                        <Card className="card-repuestos mb-5 ">
                            <Card.Header style={{ backgroundColor: '#002c5f', color: 'white' }}>
                                <h1 className='titulo-card-repuesto'>Cotiza tu Repuesto</h1>
                            </Card.Header>
                            <form onSubmit={handleSubmit(onSubmit)} id="formCotizador">
                                <Card.Body className="card-height-repuestos">
                                    <p className="h-head-r h14">* Por favor complete el siguiente formulario.</p>
                                    <Row>
                                        <Col xs={12} md={6}>
                                            <div className="input-repuestos">
                                                <label htmlFor="identificacion">Identificación:</label>
                                                <Controller
                                                    rules={{
                                                        required: 'Identificación requerida',
                                                        validate: (value) =>
                                                            verificarCedula(value) || "Cédula incorrecta"
                                                    }}
                                                    name="identificacion"
                                                    control={control}
                                                    render={({ field: { onChange, value } }) =>
                                                        <InputMask
                                                            mask="9999999999"
                                                            maskChar=" "
                                                            name="identificacion"
                                                            value={value}
                                                            onChange={onChange}
                                                        >
                                                            {(inputProps) => (
                                                                <input
                                                                    {...inputProps}
                                                                    placeholder="Identificación"
                                                                />
                                                            )}
                                                        </InputMask>}
                                                />
                                                {errors.identificacion ?
                                                    <span className="message-error-repuestos">
                                                        {errors.identificacion.message}
                                                    </span>
                                                    :
                                                    <span className="no-error">""</span>
                                                }
                                            </div>
                                            <div className="input-repuestos">
                                                <label htmlFor="nombre">Nombres:</label>
                                                <input
                                                    id="nombre"
                                                    type="text"
                                                    placeholder="Nombres"
                                                    {
                                                    ...register("nombre",
                                                        {
                                                            required: "Nombre requerido",
                                                            maxLength: 100
                                                        }
                                                    )
                                                    }
                                                />
                                                {errors.nombre ?
                                                    <span className="message-error-repuestos">
                                                        {errors.nombre.message}
                                                    </span>
                                                    :
                                                    <span className="no-error">""</span>
                                                }
                                            </div>
                                            <div className="input-repuestos">
                                                <label htmlFor="apellido">Apellidos:</label>
                                                <input type="text"
                                                    placeholder="Apellidos"
                                                    id="apellido"
                                                    {
                                                    ...register("apellido",
                                                        {
                                                            required: "Apellido requerido",
                                                            maxLength: 100
                                                        }
                                                    )
                                                    }
                                                />
                                                {errors.apellido ?
                                                    <span className="message-error-repuestos">
                                                        {errors.apellido.message}
                                                    </span>
                                                    :
                                                    <span className="no-error">""</span>
                                                }
                                            </div>
                                            <div className="input-repuestos">
                                                <label htmlFor="telefono">Teléfono: (opcional)</label>
                                                <Controller
                                                    name="telefono"
                                                    control={control}
                                                    render={({ field: { onChange, value } }) =>
                                                        <InputMask
                                                            id="telefono"
                                                            type="text"
                                                            mask="09 999 9999"
                                                            maskChar=" "
                                                            value={value}
                                                            onChange={onChange}
                                                        >
                                                            {(inputProps) => (
                                                                <input
                                                                    {...inputProps}
                                                                    placeholder="02 222 2222"
                                                                />
                                                            )}
                                                        </InputMask>
                                                    }
                                                />
                                                <span className="no-error">""</span>
                                            </div>
                                            <div className="input-repuestos">
                                                <label htmlFor="celular">Celular:</label>
                                                <Controller
                                                    rules={{ required: 'Número requerido' }}
                                                    name="celular"
                                                    control={control}
                                                    render={({ field: { onChange, value } }) =>
                                                        <InputMask
                                                            id="celular"
                                                            type="text"
                                                            mask="09 9999 9999"
                                                            maskChar=" "
                                                            value={value}
                                                            onChange={onChange}
                                                        >
                                                            {(inputProps) => (
                                                                <input
                                                                    {...inputProps}
                                                                    placeholder="09 8765 4321"
                                                                />
                                                            )}
                                                        </InputMask>
                                                    }
                                                />
                                                {errors.celular ?
                                                    <span className="message-error-repuestos">
                                                        {errors.celular.message}
                                                    </span>
                                                    :
                                                    <span className="no-error">""</span>
                                                }
                                            </div>
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <div className="input-repuestos">
                                                <label htmlFor="correo">Correo electrónico:</label>
                                                <input type="text"
                                                    placeholder="usuario@correo.com"
                                                    id="correo"
                                                    {
                                                    ...register("correo",
                                                        {
                                                            required: "Correo electrónico requerido",
                                                            maxLength: 50,
                                                            pattern: {
                                                                value: /^(([^<>()\]\\.,;:\s@”]+(\.[^<>()\]\\.,;:\s@”]+)*)|(“.+”))@((\[[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}])|(([a-zA-Z\-0–9]+\.)+[a-zA-Z]{2,}))$/,
                                                                message: "Dirrección de correo no válido"
                                                            }
                                                        }
                                                    )
                                                    }
                                                />
                                                {errors.correo ?
                                                    <span className="message-error-repuestos">
                                                        {errors.correo.message}
                                                    </span>
                                                    :
                                                    <span className="no-error">""</span>
                                                }
                                            </div>
                                            <div className="input-repuestos">
                                                <label htmlFor="chasis">Chasis:</label>
                                                <input type="text"
                                                    placeholder="____ _____ _____"
                                                    id="chasis"
                                                    maxLength={17}
                                                    {
                                                    ...register("chasis",
                                                        {
                                                            required: "Chasis requerido",
                                                            maxLength: 17
                                                        }
                                                    )
                                                    }
                                                />
                                                {errors.chasis ?
                                                    <span className="message-error-repuestos">
                                                        {errors.chasis.message}
                                                    </span>
                                                    :
                                                    <span className="no-error">""</span>
                                                }
                                            </div>
                                            <div>
                                                <div className="input-repuestos">
                                                    <label htmlFor="ciudad">Ciudad:</label>
                                                </div>
                                                <Controller
                                                    rules={{ required: 'Ciudad requerida' }}
                                                    name="selectCiudad"
                                                    control={control}
                                                    render={({ field: { onChange } }) =>
                                                        <ReactSelect
                                                            id="ciudad"
                                                            onChange={(item) => {
                                                                onChange(item);
                                                                leerCiudad(item);
                                                            }}
                                                            placeholder='Escoja una Ciudad'
                                                            options={listaCiudades}
                                                            className='select-repuestos'
                                                            theme={(theme) => ({
                                                                ...theme,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary: '#002c5f',
                                                                },

                                                            })}
                                                        />
                                                    }
                                                />
                                                <div className="input-repuestos">
                                                    {errors.selectCiudad ?
                                                        <span className="message-error-repuestos">
                                                            {errors.selectCiudad.message}
                                                        </span>
                                                        :
                                                        <span className="no-error">""</span>
                                                    }
                                                </div>
                                            </div>
                                            <div>
                                                <div className="input-repuestos">
                                                    <label htmlFor="concesionario">Concesionario:</label>
                                                </div>
                                                <Controller
                                                    rules={{ required: 'Concesionario requerido' }}
                                                    name="selectConcesionario"
                                                    control={control}
                                                    render={({ field }) =>
                                                        <ReactSelect
                                                            {...field}
                                                            id="concesionario"
                                                            placeholder='Escoja un Concesionario'
                                                            options={listaConcesonarios}
                                                            className='label-txtfield mt-0 '
                                                            theme={(theme) => ({
                                                                ...theme,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary: '#002c5f',
                                                                },

                                                            })}
                                                        />
                                                    }
                                                />
                                                <div className="input-repuestos">
                                                    {errors.selectConcesionario ?
                                                        <span className="message-error-repuestos">
                                                            {errors.selectConcesionario.message}
                                                        </span>
                                                        :
                                                        <span className="no-error">""</span>
                                                    }
                                                </div>
                                            </div>
                                            <div className="input-repuestos">
                                                <label htmlFor="descripcionRepuesto">Descripción del
                                                    repuesto: (opcional)</label>
                                                <textarea
                                                    id="descripcionRepuesto"
                                                    rows={3}
                                                    maxLength={100}
                                                    placeholder="Breve descripción del repuesto que necesita."
                                                    {
                                                    ...register("descripcionRepuesto",
                                                        {
                                                            maxLength: 200
                                                        }
                                                    )
                                                    }
                                                />
                                                {errors.descripcionRepuesto ?
                                                    <span className="message-error-repuestos">
                                                        {errors.descripcionRepuesto.message}
                                                    </span>
                                                    :
                                                    <span className="no-error">""</span>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <p className="mt-2 pl-md-4 titulo-legal">
                                            Términos y condiciones
                                        </p>
                                        <p className=" pr-md-3 pl-md-4 texto-legal">
                                            Al enviarnos tu información, autorizas de manera expresa al tratamiento y
                                            conservación de tus datos personales, según lo estipulado en la Política de
                                            Protección de Datos Personales de HYUNDAI ECUADOR
                                        </p>
                                    </Row>
                                </Card.Body>
                                <Card.Footer style={{ marginTop: '0px' }} className="footer-repuestos">
                                    <button className="btn-repuestos">
                                        Solicitar Cotización
                                    </button>
                                </Card.Footer>
                            </form>
                        </Card>
                    </Row>
                </Container>
            </div>
            <div className="menu-vehiculo" style={{ paddingTop: '100px' }}>
                <Container>
                    <Row className="centrar-global">
                        <h1 className="text-center h-head-r h24">Conoce algunas partes de tu vehículo</h1>
                    </Row>
                    <Row className="py-2 py-md-4">
                        <Col
                            xs={12}
                            md={11}
                            className="my-auto vehiculo-item text-md-center px-md-0"
                        >
                            <ul className="my-auto p-0 m-0">
                                <li
                                    id="tab-filtro-aire"
                                    onClick={() => onChangeMenu("filtro-aire")}
                                    className="color-hover"
                                >
                                    Filtro de aire
                                </li>
                                <li
                                    id="tab-pastilla-freno"
                                    onClick={() => onChangeMenu("pastilla-freno")}
                                    className="color-normal"
                                >
                                    Pastilla de freno
                                </li>
                                <li
                                    id="tab-filtro-aire-cab"
                                    onClick={() => onChangeMenu("filtro-aire-cab")}
                                    className="color-normal"
                                >
                                    Filtro de aire de cabina
                                </li>
                                <li
                                    id="tab-filtro-comb"
                                    onClick={() => onChangeMenu("filtro-comb")}
                                    className="color-normal"
                                >
                                    Filtro de combustible
                                </li>
                                <li
                                    id="tab-filtro-aceite"
                                    onClick={() => onChangeMenu("filtro-aceite")}
                                    className="color-normal"
                                >
                                    Filtro de aceite
                                </li>
                                <li
                                    id="tab-banda-distribucion"
                                    onClick={() => onChangeMenu("banda-distribucion")}
                                    className="color-normal"
                                >
                                    Banda de distribución
                                </li>
                            </ul>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/***************************************** filtro de aire ***************************************/}
            <section id="filtro-aire">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="repuestos-title">Filtro de aire.</h2>
                            <p className="repuestos-text mb-md-5 mt-3 px-3 px-md-0">
                                El filtro de aire del motor elimina el polvo y otros materiales
                                del aire y reduce el ruido de entrada de aire.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <LazyLoadImage className="imagen-grande" src={FiltroAire} alt="Hyundai filtro aire" title="Hyundai filtro aire" fluid />
                        </Col>
                    </Row>
                </Container>
                <Container className="mt-3 mb-5">
                    <Row>
                        <Col md={6} className="mt-2 my-auto">
                            <p className="repuestos-title-md">Filtro de aire.</p>
                            <p className="repuestos-text">
                                El motor necesita una mezcla exacta de combustible y aire para
                                funcionar. Todo el aire ingresa al sistema primero a través del
                                filtro de aiere. Esto atrapa la suciedad y otras partículas
                                extrañas en el aire, evitando que entren al sistema y
                                posiblemente dañen el motor.
                            </p>
                        </Col>
                        <Col md={6} className="mt-4 mt-md-0">
                            <LazyLoadImage className="imagen-mediana" src={FiltroAire2} alt="Hyundai filtro aire" title="Hyundai filtro aire" fluid />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="mt-2 mt-md-4 my-auto">
                            <p className="repuestos-text-bold-md">
                                La calidad del filtro de aire no puede ser juzgada simplemente
                                por la apariencia. Sólo el filtro de aire Hyundai genuino está
                                diseñado y diseñado específicamente para su vehículo Hyundai; en
                                la conducción sin problemas, siempre pregunte por el filtro de
                                aire Hyundai genuino.
                            </p>
                            <p className="repuestos-text-md">
                                *Algunas fotos en esta web han sido tomadas bajo condiciones
                                controladas, mientras que otras no. Los colores y las imágenes
                                mostradas se someten a pantallas de visualización y son solo
                                aproximaciones. Las imágenes mostradas en esta web pueden
                                diferir ligeramente de las especificaciones reales de color y
                                productos.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </section>
            {/***************************************** pastilla de freno ***************************************/}
            <section id="pastilla-freno" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="repuestos-title">Pastilla de freno.</h2>
                            <p className="repuestos-text mb-md-5 mt-3 px-3 px-md-0">
                                La pastilla de freno agarra el freno de disco para producir una
                                fuerza de frenado.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <LazyLoadImage className="imagen-grande" src={PastillaFreno} alt="Hyundai pastilla freno" title="Hyundai pastilla freno" fluid />
                        </Col>
                    </Row>
                </Container>
                <Container className="mt-3 mb-5">
                    <Row>
                        <Col md={6} className="mt-2 my-auto">
                            <p className="repuestos-title-md">Pastilla de freno.</p>
                            <p className="repuestos-text">
                                Las pastillas de freno son placas de soporte de acero con
                                materiales de fricción unidos a la superficie que se enfrenta al
                                rotor del freno de disco. Transmite la presión aplicada al pedal
                                del freno a las ruedas y detiene o desacelera el movimiento del
                                vehículo.
                            </p>
                        </Col>
                        <Col md={6} className="mt-4 mt-md-0">
                            <LazyLoadImage className="imagen-mediana" src={PastillaFreno2} alt="Hyundai pastilla freno" title="Hyundai pastilla freno" fluid />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="mt-2 mt-md-4 my-auto">
                            <p className="repuestos-text-bold-md">
                                La calidad de la pastilla de freno no se puede juzgar
                                simplemente por su apariencia. Solo las pastillas de freno
                                Hyundai genuinas están diseñadas y diseñadas específicamente
                                para su vehículo Hyundai; sobre su conducción sin problemas,
                                siempre solicite una passtilla de freno Hyundai genuina.
                            </p>
                            <p className="repuestos-text-md">
                                *Algunas fotos en esta web han sido tomadas bajo condiciones
                                controladas, mientras que otras no. Los colores y las imágenes
                                mostradas se someten a pantallas de visualización y son solo
                                aproximaciones. Las imágenes mostradas en esta web pueden
                                diferir ligeramente de las especificaciones reales de color y
                                productos.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </section>
            {/*****************************************  filtro de aire de cabina ***************************************/}
            <section id="filtro-aire-cab">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="repuestos-title">Filtro de aire.</h2>
                            <p className="repuestos-text mb-md-5 mt-3 px-3 px-md-0">
                                El filtro de aire de la cabina limpia el aire que ingresa al
                                interior a través del sistema de calefacción, ventilación y aire
                                acondicionado.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <LazyLoadImage className="imagen-grande" src={FiltroCabina} alt="Hyundai filtro cabina" title="Hyundai filtro cabina" fluid />
                        </Col>
                    </Row>
                </Container>
                <Container className="mt-3 mb-5">
                    <Row>
                        <Col md={6} className="mt-2 my-auto">
                            <p className="repuestos-title-md">Filtro de aire de cabina.</p>
                            <p className="repuestos-text">
                                El polvo capturado en cualquier filtro de aire de la cabina
                                provoca una reducción gradual del flujo de aire durante la vida
                                útil de la pieza, lo que resulta en una pérdida del rendimiento
                                del motor y un bajo consumo de combustible. Su función también
                                es proporcionar un flujo de aire óptimo al motor.
                            </p>
                        </Col>
                        <Col md={6} className="mt-4 mt-md-0">
                            <LazyLoadImage className="imagen-mediana" src={FiltroCabina2} alt="Hyundai filtro cabina" title="Hyundai filtro cabina" fluid />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="mt-2 mt-md-4 my-auto">
                            <p className="repuestos-text-bold-md">
                                La calidad del filtro de aire de la cabina no se puede juzgar
                                simplemente por su apariencia. Solo el genuino filtro de aire de
                                la cabina Hyundai está diseñado y diseñado específicamente para
                                su vehículo Hyundai; sobre su conducción sin problemas, siempre
                                solicite una passtilla de freno Hyundai genuina.
                            </p>
                            <p className="repuestos-text-md">
                                *Algunas fotos en esta web han sido tomadas bajo condiciones
                                controladas, mientras que otras no. Los colores y las imágenes
                                mostradas se someten a pantallas de visualización y son solo
                                aproximaciones. Las imágenes mostradas en esta web pueden
                                diferir ligeramente de las especificaciones reales de color y
                                productos.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </section>
            {/***************************************** filtro de combustible ***************************************/}
            <section id="filtro-comb" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="repuestos-title">Filtro de combustible.</h2>
                            <p className="repuestos-text mb-md-5 mt-3 px-3 px-md-0">
                                El filtro de combustible evita que la bomba de combustible se
                                obstruya y funcione mal al eliminar impurezas como polvo
                                ypartículas de acero.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <LazyLoadImage
                                className="imagen-grande"
                                src={FiltroCombustible}
                                alt="Hyundai filtro combustible"
                                title="Hyundai filtro combustible"
                                fluid
                            />
                        </Col>
                    </Row>
                </Container>
                <Container className="mt-3 mb-5">
                    <Row>
                        <Col md={6} className="mt-2 my-auto">
                            <p className="repuestos-title-md">Filtro de combustible.</p>
                            <p className="repuestos-text">
                                El filtro de combustible evita la abrasión dentro de los
                                cilindros, particularmente en las secciones superiores. Si el
                                filtro de combustible no se reemplaza con regularidad, puede
                                obstruirse con contaminantes y causar una restricción en el
                                flujo de combustible, causando una caída significativa en el
                                rendimiento del motor.
                            </p>
                        </Col>
                        <Col md={6} className="mt-4 mt-md-0">
                            <LazyLoadImage
                                className="imagen-mediana"
                                src={FiltroCombustible2}
                                alt="Hyundai filtro combustible"
                                title="Hyundai filtro combustible"
                                fluid
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="mt-2 mt-md-4 my-auto">
                            <p className="repuestos-text-bold-md">
                                La calidad del filtro de combustible no puede ser juzgada
                                simplemente por la apariencia. Sólo el filtro de combustible
                                Hyundai genuino está diseñado y diseñado específicamente para su
                                vehículo Hyundai; en la conducción sin problemas, siempre
                                pregunte por el filtro de aire Hyundai genuino.
                            </p>
                            <p className="repuestos-text-md">
                                *Algunas fotos en esta web han sido tomadas bajo condiciones
                                controladas, mientras que otras no. Los colores y las imágenes
                                mostradas se someten a pantallas de visualización y son solo
                                aproximaciones. Las imágenes mostradas en esta web pueden
                                diferir ligeramente de las especificaciones reales de color y
                                productos.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </section>
            {/***************************************** filtro de aceite ***************************************/}
            <section id="filtro-aceite" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="repuestos-title">Filtro de aceite.</h2>
                            <p className="repuestos-text mb-md-5 mt-3 px-3 px-md-0">
                                El filtro de aceite interno filtra el aceite del motor y elimina
                                los contaminantes, manteniendo limpio el aceite del motor.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <LazyLoadImage className="imagen-grande" src={FiltroAceite} alt="Hyundai filtro aceite" title="Hyundai filtro aceite" fluid />
                        </Col>
                    </Row>
                </Container>
                <Container className="mt-3 mb-5">
                    <Row>
                        <Col md={6} className="mt-2 my-auto">
                            <p className="repuestos-title-md">Filtro de aceite.</p>
                            <p className="repuestos-text">
                                A medida que el aceite circula por el motor, se contamina con el
                                tiempo.
                            </p>
                            <p className="repuestos-text">
                                Un filtro de aceite eliminará estas impurezas para garantizar el
                                buen funcionamiento del motor.
                            </p>
                        </Col>
                        <Col md={6} className="mt-4 mt-md-0">
                            <LazyLoadImage className="imagen-mediana" src={FiltroAceite2} alt="Hyundai filtro aceite" title="Hyundai filtro aceite" fluid />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="mt-2 mt-md-4 my-auto">
                            <p className="repuestos-text-bold-md">
                                La calidad del filtro de aceite no puede ser juzgada simplemente
                                por la apariencia. Sólo el filtro de aceite Hyundai genuino está
                                diseñado y diseñado específicamente para su vehículo Hyundai; en
                                la conducción sin problemas, siempre pregunte por el filtro de
                                aire Hyundai genuino.
                            </p>
                            <p className="repuestos-text-md">
                                *Algunas fotos en esta web han sido tomadas bajo condiciones
                                controladas, mientras que otras no. Los colores y las imágenes
                                mostradas se someten a pantallas de visualización y son solo
                                aproximaciones. Las imágenes mostradas en esta web pueden
                                diferir ligeramente de las especificaciones reales de color y
                                productos.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </section>
            {/***************************************** Banda de distribución ***************************************/}
            <section id="banda-distribucion" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="repuestos-title">Banda de distribución.</h2>
                            <p className="repuestos-text mb-md-5 mt-3 px-3 px-md-0">
                                Una banda de distribución controla los árboles de levas en su
                                motor, abriendo y cerrando válvulas en el momento justo para una
                                operación suave.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <LazyLoadImage
                                className="imagen-grande"
                                src={BandaDistribucion}
                                alt="Hyundai banda distribución"
                                title="Hyundai banda distribución"
                                fluid
                            />
                        </Col>
                    </Row>
                </Container>
                <Container className="mt-3 mb-5 mt-md-5">
                    <Row>
                        <Col md={6} className="mt-2 my-auto">
                            <p className="repuestos-title-md">Banda de distribución.</p>
                            <p className="repuestos-text">
                                La correa de distribución debe estar correctamente calibrada
                                para moverse en secuencia con el movimiento de los pistones.
                                Independientemente del tipo de motor que esté presente en su
                                vehículo, una falla en la correa de distribución hará que el
                                motor se detenga repentinamente. Las bandas de distribución
                                están presentes en los motores con levas en la parte superior y
                                son esenciales para mantener estas levas girando en el momento
                                adecuado para mantener el motor en funcionamiento.
                            </p>
                        </Col>
                        <Col md={6} className="mt-4 mt-md-0">
                            <LazyLoadImage
                                className="imagen-mediana"
                                src={BandaDistribucion2}
                                alt="Hyundai banda de distribución"
                                title="Hyundai banda de distribución"
                                fluid
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="mt-2 mt-md-4 my-auto">
                            <p className="repuestos-text-bold-md">
                                La calidad de la banda de distribución no puede ser juzgada
                                simplemente por la apariencia. Sólo la banda de distribución
                                Hyundai genuina está diseñada y diseñada específicamente para su
                                vehículo Hyundai; en la conducción sin problemas, siempre
                                pregunte por el filtro de aire Hyundai genuino.
                            </p>
                            <p className="repuestos-text-md">
                                *Algunas fotos en esta web han sido tomadas bajo condiciones
                                controladas, mientras que otras no. Los colores y las imágenes
                                mostradas se someten a pantallas de visualización y son solo
                                aproximaciones. Las imágenes mostradas en esta web pueden
                                diferir ligeramente de las especificaciones reales de color y
                                productos.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
}
export default InfoCotizaRepuestos;